import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pxa-simulador',
  templateUrl: './pxa-simulador.component.html',
  styleUrls: ['./pxa-simulador.component.scss']
})
export class PxaSimuladorComponent implements OnInit {

  resultado: any = null;
  buscado: boolean = false;

  grupoVal = new FormGroup({
    EXCHANGE_ID: new FormControl(''),
    DEPARTMENT_CODE: new FormControl(''),
    SOURCE_APPLICATION: new FormControl(''),
    EMPLOYEE_ID: new FormControl('')
  });

  constructor(
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<PxaSimuladorComponent>,
    private gateway: GatewayService
  ) { }

  ngOnInit() { }

  simular() {
    this.spinner.show();
    this.buscado = false;

    const params = {
      EXCHANGE_ID: this.grupoVal.controls.EXCHANGE_ID.value || null,
      DEPARTMENT_CODE: this.grupoVal.controls.DEPARTMENT_CODE.value || null,
      SOURCE_APPLICATION: this.grupoVal.controls.SOURCE_APPLICATION.value || null,
      EMPLOYEE_ID: this.grupoVal.controls.EMPLOYEE_ID.value || null
    };

    this.gateway.get('simularpxa', params).then((res: any) => {
      this.resultado = res;
      this.buscado = true;
      this.spinner.hide();
    }).catch((e) => {
      this.resultado = null;
      this.buscado = true;
      this.spinner.hide();
    });
  }

  cerrar() {
    this.dialogRef.close();
  }
}
